import {StyleSheet} from 'react-native';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      marginHorizontal: 24,
      marginTop: 16,
      marginBottom: 16,
    },
    marginTop16: {
      marginTop: 16,
    },
    newNoteButton: {
      borderStyle: 'dotted',
      borderWidth: 1.5,
      borderRadius: 8,
      borderColor: colors.link,
      padding: 16,
      backgroundColor: colors.surface,
      marginTop: 16,
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    allValuesWebStyle: {
      flex: 1,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 16,
      marginBottom: 48,
    },
  });

export default makeStyles;
